import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { translate } from 'react-i18next';
import Parser from 'html-react-parser';
import $ from 'jquery';

const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class QuestionsResponse extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getQuestions = this.getQuestions.bind(this);
        this.onSave = this.onSave.bind(this);
        this.clear = this.clear.bind(this);
        this.getResponse = this.getResponse.bind(this);

        this.state = {
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            disable:false,
            date_response:"",
            exclusion_by_questionnaire:{}
        }

    }

    componentDidMount(){
        if(this.props.location.pathname !== '/interview'){
            this.setState({disable: true});
        }

        fetch(Config.default.apiGateway.URL+'functional_criterion?code=EXCLUSION_BY_QUESTIONNAIRE&x=',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      exclusion_by_questionnaire: response
		    });
		})
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    onSearch(){
        this.props.waiting.handleShow('Buscando...');
        fetch(Config.default.apiGateway.URL+'offers/check/'+this.state.no_offer,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                await this.clear();
                
                await this.setState({
                    id:response.id,
                    date: moment(response.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm:ss')
                })
                
                await this.getQuestions();
            }
        })
    }

    getQuestions(){
        fetch(Config.default.apiGateway.URL+'questionaries/by_center/'+sessionStorage.getItem('health_facilities_id'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                response.questions.map((q)=>
                    q.field_type === 'DATE' ?
                        q.html = q.html.replace('form-control date', 'form-control date hour-input')
                    : null
                );


                await this.setState({questions: response.questions, questionary_id:response.id});

                if(this.state.disable){
                    await this.getResponse();
                }
                
            }
        })
    }

    getResponse(){
        fetch(Config.default.apiGateway.URL+'offer_questionnaire?offer_id='+this.state.id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    var res = JSON.parse(msg);
                    swal('Error', res.Message, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.state.questions.map((q)=>{
                    var index = response.questionnaire_response.findIndex(obj => obj.ask_id === q.id);
                    var control = document.getElementById(q.id);
                    if(index !== -1){                        
                        control.value = response.questionnaire_response[index].answer;
                    }

                    control.disabled = true;
                })

                this.setState({
                    self_exclusion: response.self_exclusion,
                    date_response: moment(response.timestamp).format('DD/MM/YYYY HH:mm:ss')
                })
            }
        })
    }

    onSave(e){
        e.preventDefault();
        var obj = {
            questionary_id: this.state.questionary_id,
            offer_id: this.state.id,
            questionnaire_response:[]
        };

        this.state.questions.map((q)=>{
            var control = document.getElementById(q.id);
            var item = {};

            if(control !== null){
                item = {
                    ask_id: q.id,
                    answer: control.value
                };

                if(control.value !== ""){
                    obj.questionnaire_response.push(item);
                }
            }

            return q;
        });

        if(this.state.exclusion_by_questionnaire.value === 'YES'){
            obj.self_exclusion = this.state.self_exclusion;
        }else{
            obj.self_exclusion = null;
        }

        if(this.isValidForm()){
            if(obj.questionnaire_response.length > 0){
                this.props.waiting.handleShow('Guardando...');
                fetch(Config.default.apiGateway.URL+'offer_questionnaire',{
                    method:'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg) => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        swal('Correcto', 'Los datos se guardaron correctamente', 'success');
                        this.clear();
                    }
                })
            }else{
                swal('Error', 'Debe contestar por lo menos una pregunta', 'error');
            }
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
             
                if (!isInputValid) {                    
                    vacio = true;
                }
            }
	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
    }

    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

        if(control !== null){
            if(control.required){
                if(control.value === ""){
                    control.classList.add('error');
                    res = false;
                    
                }else{
                    if(control.className.includes('error')){
                        control.classList.remove('error');
                        
                    }
                    res = true;
                }

            }
        }
		
		return res;		
	}
    
    clear(){
        this.setState({
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            date_response:""
        });
    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {session} ->
                        {t('sidebar.nav.donors.MAIN')} -> 
                        Encuesta
                    </h5>
                </div>

                <Help
                    {...this.props}
                    menu={"help_donors"} 
                    submenu={"help_offers_questionary"}  />
                
                <div className="col-xs-12">
                    <div className="col-xs-12">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Número de ofrecimiento</span>
                            <input type="number" className="form-control input-sm hour-input" 
                                name="no_offer" id="no_offer" value={this.state.no_offer} 
                                onChange={(e)=>this.handleChange(e)}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-1" style={{marginTop:20}}>
                            <button className="btn btn-info" onClick={()=>this.onSearch()}>Buscar</button>
                        </div>
                    </div>
                    {this.state.id !== "" &&
                        <div className="col-xs-12">
                            <hr />
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-1">
                                    <span className="span-min">Id:</span>
                                </div>
                                <div className="col-xs-12 col-sm-10">
                                    <span>{this.state.id}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-1">
                                    <span className="span-min">Fecha:</span>
                                </div>
                                <div className="col-xs-12 col-sm-10">
                                    <span>{this.state.date}</span>
                                </div>
                            </div>
                            {this.state.disable &&
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-1">
                                        <span className="span-min">Respondido el:</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-10">
                                        <span>{this.state.date_response}</span>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    }

                    {this.state.questions.length > 0 &&
                        <form className="col-xs-12">
                            <hr/>
                            <div className="col-xs-12 form-group">
                                <fieldset style={{padding:8}}>
                                    <legend>AUTOEXCLUSIÓN</legend>

                                    {this.state.exclusion_by_questionnaire.value === 'YES' &&
                                        <div className="col-xs-12 col-sm-12 form-group">
                                            <div className="col-xs-12 col-sm-6">
                                                <span className="span-min">¿CONSIDERA QUE SU SANGRE ES SEGURA?</span>
                                            </div>
                                            <div className="col-xs-12 col-sm-2">
                                                <select className="form-control" name="self_exclusion" id="self_exclusion" 
                                                    value={this.state.self_exclusion} onChange={(e)=>this.handleChange(e)}
                                                    disabled>
                                                    <option value="">Seleccione...</option>
                                                    <option value={true}>No, mi sangre no es segura</option>
                                                    <option value={false}>Si, mi sangre es segura</option>
                                                </select>
                                            </div>
                                        </div>
                                    }
                                </fieldset>
                                
                                <fieldset style={{padding:8}}>
                                    <legend>ENCUESTA</legend>

                                    {this.state.questions.map((q, i)=>                                    
                                        <div className="col-xs-12 col-sm-12 form-group" key={i}>
                                            <div className="col-xs-12 col-sm-6">
                                                <span className="span-min">{q.field_label}</span>
                                            </div>
                                            <div className={q.html.indexOf('select') !== -1 ?
                                                "col-xs-12 col-sm-2"
                                            :
                                                "col-xs-12 col-sm-4"
                                            }>
                                                {Parser(q.html)}
                                            </div>
                                        </div>
                                    )}
                                </fieldset>
                               

                                
                            </div>
                            {!this.state.disable &&
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <button className="btn btn-info" onClick={(e)=>this.onSave(e)}>Guardar</button>
                                </div>
                            }
                        </form>
                    }

                </div>
            </div>
        )
    }
    
}

export default translate('translations')(QuestionsResponse);